import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
import { Icon } from '../system/icons';
const TONE_STYLE = {
    neutral: { bg: 'var(--accent)', ink: 'var(--foreground)', accent: 'var(--primary)' },
    poppy: { bg: 'var(--light-poppy)', ink: 'var(--primary)', accent: 'var(--primary)' },
    yellow: { bg: 'var(--light-yellow)', ink: '#6b4f00', accent: '#6b4f00' },
    green: { bg: 'var(--light-green)', ink: 'var(--palette-emerald)', accent: 'var(--palette-emerald)' },
    lilac: { bg: 'var(--light-lilac)', ink: 'var(--palette-navy)', accent: 'var(--palette-navy)' },
};
export function CalloutBar({ tone = 'neutral', icon, label, meta, right, bordered = true, padX = 'xl', padY = 'md', align = 'center', style, }) {
    const t = TONE_STYLE[tone];
    return (_jsxs(Row, { gap: "sm", align: align === 'start' ? 'flex-start' : 'center', style: {
            padding: `var(--space-${padY}) var(--space-${padX})`,
            background: t.bg,
            borderBottom: bordered ? '1px solid var(--border)' : 'none',
            ...style,
        }, children: [icon && _jsx(Icon, { size: "sm", color: t.accent, children: icon }), label && _jsx("span", { style: { font: 'var(--type-label-sm)', color: t.ink }, children: label }), meta && _jsxs("span", { style: { font: 'var(--type-caption)', color: 'var(--muted-foreground)' }, children: ["\u00B7 ", meta] }), right && _jsxs(_Fragment, { children: [_jsx("div", { style: { flex: 1 } }), right] })] }));
}
//# sourceMappingURL=CalloutBar.js.map